module.exports = __webpack_public_path__ + "img/room-safe.2c1683e2.svg";